import {emotionStyled} from '@packages/utilities/styled';
import {hoverSelector} from '../../utils';
import {IconButton} from '../IconButton';

export const CloseButtonView = emotionStyled(IconButton)({
  [hoverSelector]: {
    background: '$closeButtonBackground',
  },
});
